<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b" id="abb"><a id="page_xv"></a>Abbreviations and Acronyms</h2>
<table>
<tbody>
<tr>
<td><p class="abbr">AAS</p></td>
<td><p class="abb">American Astronautical Society</p></td>
</tr>
<tr>
<td><p class="abbr">ABMA</p></td>
<td><p class="abb">Army Ballistic Missile Agency</p></td>
</tr>
<tr>
<td><p class="abbr">AF</p></td>
<td><p class="abb">air force</p></td>
</tr>
<tr>
<td><p class="abbr">AFHRA</p></td>
<td><p class="abb">Air Force Historical Research Agency</p></td>
</tr>
<tr>
<td><p class="abbr">AFSC</p></td>
<td><p class="abb">Air Force Systems Command</p></td>
</tr>
<tr>
<td><p class="abbr">AMC</p></td>
<td><p class="abb">Air Materiel Command</p></td>
</tr>
<tr>
<td><p class="abbr">ARDC</p></td>
<td><p class="abb">Air Research and Development Command</p></td>
</tr>
<tr>
<td><p class="abbr">ASAT</p></td>
<td><p class="abb">Arbeitsgemeinschaft Satelitenträger</p></td>
</tr>
<tr>
<td><p class="abbr">AT&amp;T</p></td>
<td><p class="abb">American Telephone and Telegraph</p></td>
</tr>
<tr>
<td><p class="abbr">ATC</p></td>
<td><p class="abb">Air Training Command</p></td>
</tr>
<tr>
<td><p class="abbr">BMC</p></td>
<td><p class="abb">Ballistic Missile Command</p></td>
</tr>
<tr>
<td><p class="abbr">BSD</p></td>
<td><p class="abb">Ballistic Systems Division</p></td>
</tr>
<tr>
<td><p class="abbr">CBI</p></td>
<td><p class="abb">Charles Babbage Institute</p></td>
</tr>
<tr>
<td><p class="abbr">CCB</p></td>
<td><p class="abb">configuration control board</p></td>
</tr>
<tr>
<td><p class="abbr">CERN</p></td>
<td><p class="abb">Conseil Européen pour Recherche Nucléaire</p></td>
</tr>
<tr>
<td><p class="abbr">CETS</p></td>
<td><p class="abb">Conférence Européene de Télécommunications par Satellites</p></td>
</tr>
<tr>
<td><p class="abbr">CNES</p></td>
<td><p class="abb">Centre National d’Études Spatiales</p></td>
</tr>
<tr>
<td><p class="abbr">COPERS</p></td>
<td><p class="abb">Commission Préparatoire Européene de Recherches Spatiales</p></td>
</tr>
<tr>
<td><p class="abbr">CPFF</p></td>
<td><p class="abb">cost plus fixed fee</p></td>
</tr>
<tr>
<td><p class="abbr">DCAS</p></td>
<td><p class="abb">Deputy Commander for Aerospace Systems</p></td>
</tr>
<tr>
<td><p class="abbr">DOD</p></td>
<td><p class="abb">Department of Defense</p></td>
</tr>
<tr>
<td><p class="abbr">ELDO</p></td>
<td><p class="abb">European Space Vehicle Launcher Development Organisation</p></td>
</tr>
<tr>
<td><p class="abbr">ERNO</p></td>
<td><p class="abb">Entwicklungsring Nord</p></td>
</tr>
<tr>
<td><p class="abbr">ESA</p></td>
<td><p class="abb">European Space Agency</p></td>
</tr>
<tr>
<td><p class="abbr">ESRO</p></td>
<td><p class="abb">European Space Research Organisation</p></td>
</tr>
<tr>
<td><p class="abbr">ESTEC</p></td>
<td><p class="abb">European Space Technology Centre</p></td>
</tr>
<tr>
<td><p class="abbr"><a id="page_xvi"></a>EUI</p></td>
<td><p class="abb">European University Institute</p></td>
</tr>
<tr>
<td><p class="abbr">GE</p></td>
<td><p class="abb">General Electric</p></td>
</tr>
<tr>
<td><p class="abbr">GSFC</p></td>
<td><p class="abb">Goddard Space Flight Center</p></td>
</tr>
<tr>
<td><p class="abbr">HAC</p></td>
<td><p class="abb">Hughes Aircraft Company</p></td>
</tr>
<tr>
<td><p class="abbr">HAEUI</p></td>
<td><p class="abb">Historical Archives of the European University Institute</p></td>
</tr>
<tr>
<td><p class="abbr">HEOS</p></td>
<td><p class="abb">Highly Eccentric Orbit Satellite</p></td>
</tr>
<tr>
<td><p class="abbr">HQ</p></td>
<td><p class="abb">headquarters</p></td>
</tr>
<tr>
<td><p class="abbr">HSO</p></td>
<td><p class="abb">History Support Office</p></td>
</tr>
<tr>
<td><p class="abbr">IBM</p></td>
<td><p class="abb">International Business Machines</p></td>
</tr>
<tr>
<td><p class="abbr">ICBM</p></td>
<td><p class="abb">intercontinental ballistic missile</p></td>
</tr>
<tr>
<td><p class="abbr">IRBM</p></td>
<td><p class="abb">intermediate-range ballistic missile</p></td>
</tr>
<tr>
<td><p class="abbr">JPL</p></td>
<td><p class="abb">Jet Propulsion Laboratory</p></td>
</tr>
<tr>
<td><p class="abbr">JPLA</p></td>
<td><p class="abb">JPL Archives</p></td>
</tr>
<tr>
<td><p class="abbr">JSC</p></td>
<td><p class="abb">Johnson Space Center</p></td>
</tr>
<tr>
<td><p class="abbr">KSC</p></td>
<td><p class="abb">Kennedy Space Center</p></td>
</tr>
<tr>
<td><p class="abbr">LC/SPP</p></td>
<td><p class="abb">Library of Congress, Samuel Phillips Papers</p></td>
</tr>
<tr>
<td><p class="abbr">LCT</p></td>
<td><p class="abb">Laboratoire Central de Télécommunications</p></td>
</tr>
<tr>
<td><p class="abbr">LEM</p></td>
<td><p class="abb">Lunar Excursion Module</p></td>
</tr>
<tr>
<td><p class="abbr">MAU</p></td>
<td><p class="abb">million accounting units</p></td>
</tr>
<tr>
<td><p class="abbr">MBB</p></td>
<td><p class="abb">Messerschmitt-Bölkow-Blohm</p></td>
</tr>
<tr>
<td><p class="abbr">MESH</p></td>
<td><p class="abb">Matra, Entwicklungsring Nord, Saab, and Hawker Siddeley</p></td>
</tr>
<tr>
<td><p class="abbr">MIS</p></td>
<td><p class="abb">management information system</p></td>
</tr>
<tr>
<td><p class="abbr">MIT</p></td>
<td><p class="abb">Massachusetts Institute of Technology</p></td>
</tr>
<tr>
<td><p class="abbr">MSC</p></td>
<td><p class="abb">Manned Spacecraft Center</p></td>
</tr>
<tr>
<td><p class="abbr">MSFC</p></td>
<td><p class="abb">Marshall Space Flight Center</p></td>
</tr>
<tr>
<td><p class="abbr">NAA</p></td>
<td><p class="abb">North American Aviation</p></td>
</tr>
<tr>
<td><p class="abbr">NACA</p></td>
<td><p class="abb">National Advisory Committee for Aeronautics</p></td>
</tr>
<tr>
<td><p class="abbr">NASA</p></td>
<td><p class="abb">National Aeronautics and Space Administration</p></td>
</tr>
<tr>
<td><p class="abbr">NASAHO</p></td>
<td><p class="abb">NASA History Office</p></td>
</tr>
<tr>
<td><p class="abbr">NATO</p></td>
<td><p class="abb">North Atlantic Treaty Organization</p></td>
</tr>
<tr>
<td><p class="abbr">OECD</p></td>
<td><p class="abb">Organization for Economic Cooperation and Development</p></td>
</tr>
<tr>
<td><p class="abbr">OMSF</p></td>
<td><p class="abb">Office of Manned Space Flight</p></td>
</tr>
<tr>
<td><p class="abbr">PDR</p></td>
<td><p class="abb">Preliminary Design Review</p></td>
</tr>
<tr>
<td><p class="abbr">PERT</p></td>
<td><p class="abb">Program Evaluation and Review Technique (or Research Task)</p></td>
</tr>
<tr>
<td><p class="abbr">QA</p></td>
<td><p class="abb">quality assurance</p></td>
</tr>
<tr>
<td><p class="abbr"><a id="page_xvii"></a>R&amp;D</p></td>
<td><p class="abb">research and development</p></td>
</tr>
<tr>
<td><p class="abbr">RCA</p></td>
<td><p class="abb">Radio Corporation of America</p></td>
</tr>
<tr>
<td><p class="abbr">RFP</p></td>
<td><p class="abb">request for proposal</p></td>
</tr>
<tr>
<td><p class="abbr">R-W</p></td>
<td><p class="abb">Ramo-Wooldridge</p></td>
</tr>
<tr>
<td><p class="abbr">S&amp;ID</p></td>
<td><p class="abb">Space and Information Systems Division</p></td>
</tr>
<tr>
<td><p class="abbr">SAC</p></td>
<td><p class="abb">Strategic Air Command</p></td>
</tr>
<tr>
<td><p class="abbr">SAPO</p></td>
<td><p class="abb">Special Aircraft Projects Office</p></td>
</tr>
<tr>
<td><p class="abbr">SE</p></td>
<td><p class="abb">systems engineering</p></td>
</tr>
<tr>
<td><p class="abbr">SEREB</p></td>
<td><p class="abb">Société pour l’Étude et la Réalisation d’Engins Balistiques</p></td>
</tr>
<tr>
<td><p class="abbr">SETIS</p></td>
<td><p class="abb">Société d’Étude et d’Intégration de Systèmes Spatiaux</p></td>
</tr>
<tr>
<td><p class="abbr">SMC</p></td>
<td><p class="abb">USAF Space and Missile Center</p></td>
</tr>
<tr>
<td><p class="abbr">STG</p></td>
<td><p class="abb">Space Task Group</p></td>
</tr>
<tr>
<td><p class="abbr">STL</p></td>
<td><p class="abb">Space Technology Laboratories</p></td>
</tr>
<tr>
<td><p class="abbr">TD</p></td>
<td><p class="abb">Thor-Delta</p></td>
</tr>
<tr>
<td><p class="abbr">TQM</p></td>
<td><p class="abb">total quality management</p></td>
</tr>
<tr>
<td><p class="abbr">TRW</p></td>
<td><p class="abb">Thompson-Ramo-Wooldridge</p></td>
</tr>
<tr>
<td><p class="abbr">USAF</p></td>
<td><p class="abb">U.S. Air Force</p></td>
</tr>
<tr>
<td><p class="abbr">WADC</p></td>
<td><p class="abb">Wright Air Development Center</p></td>
</tr>
<tr>
<td><p class="abbr">WDD</p></td>
<td><p class="abb">Western Development Division</p></td>
</tr>
<tr>
<td><p class="abbr">WSPO</p></td>
<td><p class="abb">Weapon System Project Office<a id="page_xviii"></a></p></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abb.vue?f9c4fe04